export default __webpack_public_path__ + "static/media/git.6ca95f10.png";